import React, { useEffect } from 'react';
import './Home.css'; // Make sure to import the CSS
import laptopImage from '../images/laptop.png'; // Import the laptop image
import iphoneImage from '../images/mobile.png'; // <-- ADDED: Import the iPhone image

export default function Home() {
  useEffect(() => {
    let link = document.querySelector("link[rel='canonical']");
    if (!link) { link = document.createElement('link'); link.rel = 'canonical'; document.head.appendChild(link); }
    link.href = 'https://www.ceylonext.com/';
    document.title = 'CeyloNext';
  }, []);

  return (
    <main className="main-content">
      <div className="hero-section">
        {/* Your existing hero text */}
        <div className="hero-text">
          <h1>WE</h1>
          <h1>CREATE</h1>
          <h1>IMPACT.</h1>
          <p>
            Blending creativity with technology, we design, build, and evolve
            digital experiences that empower brands and inspire people.
          </p>
        </div>


        {/* ADDED: A new container for both images */}
        <div className="hero-images-container">
          <div className="hero-image laptop-image"> {/* Existing laptop image */}
            <img src={laptopImage} alt="Laptop with digital solutions" />
          </div>
          <div className="hero-image iphone-image"> {/* New iPhone image */}
            <img src={iphoneImage} alt="iPhone displaying a profile" />
          </div>
        </div>

      </div> {/* End of hero-section wrapper */}

      <div className="graphics-placeholder">
        <div className="sphere"></div>
        <div className="liquid-blob"></div>
      </div>

      <div className="team-widget">
        <img src="https://i.pravatar.cc/40?img=1" alt="User 1" />
        <img src="https://i.pravatar.cc/40?img=2" alt="User 2" />
        <img src="https://i.pravatar.cc/40?img=3" alt="User 3" />
        <p>Trusted by 77+ clients</p>
      </div>
    </main>
  );
}